import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meeteam',
  templateUrl: './meeteam.component.html',
  styleUrls: ['./meeteam.component.css']
})
export class MeeteamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
